import React from "react";

import { SwaggerFpsDao, FpsService, FpsSwagger } from "@egis-smartcity/parking";
import FpsContext, { FpsState } from "./FpsContext";
import useAuth from "../../hooks/useAuth";
import useCityConfig from "../../hooks/useCityConfig";

export type FpsProviderProps = React.PropsWithChildren<{}>;

function FpsProvider(props: FpsProviderProps) {
  const { children } = props;
  const { token } = useAuth();
  const { cityConfig } = useCityConfig();

  const fpsService: FpsService | undefined = React.useMemo(() => {
    if (!cityConfig || !token) return;

    const apiKey = `Bearer ${token}`;

    const fpsSwaggerClient = new FpsSwagger.FpsApi(
      new FpsSwagger.Configuration({
        basePath: cityConfig.review.fps.url,
        apiKey,
      })
    );
    const fpsMediaSwaggerClient = new FpsSwagger.MediaApi(
      new FpsSwagger.Configuration({
        basePath: cityConfig.review.fps.url + "/api/v1",
        apiKey,
      })
    );
    const swaggerFpsDao = new SwaggerFpsDao(
      fpsSwaggerClient,
      fpsMediaSwaggerClient
    );

    return new FpsService(swaggerFpsDao);
  }, [cityConfig, token]);

  const fpsState: FpsState = React.useMemo(() => {
    return { fpsService };
  }, [fpsService]);

  return <FpsContext.Provider value={fpsState}>{children}</FpsContext.Provider>;
}

export default FpsProvider;
